<template>
  <section
    class="worldMapTop"
  >
    <TableList
      :area-id="props.area"
      :list="props.arrayOtherPoint"
      :target-name="`${props.countryName}の都市`"
      target="country"
    />
  </section>
</template>

<script setup>
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

const props = defineProps({
  country: {
    type: String,
    required: true
  },
  countryName: {
    type: String,
    required: true
  },
  area: {
    type: String,
    required: true
  },
  arrayOtherPoint: {
    type: Array,
    required: true
  }
})
</script>
